/**
 * Vorabinformationen (PDF) der Startseite. Die veröffentlichte Liste ist ohne Anmeldung abrufbar,
 * die Verwaltung braucht das Admin-Access-Token (Scopes read:/write:attachments).
 */
async function throwIfNotOk(response) {
  if (response.ok) {
    return
  }

  let message = `HTTP ${response.status}`

  try {
    const body = await response.json()

    if (body.message) {
      message = body.message
    }
  } catch (e) {
    // kein JSON-Body
  }

  const error = new Error(message)
  error.status = response.status

  throw error
}

function authHeaders(options) {
  return {
    'Authorization': `Bearer ${options.accessToken}`
  }
}

export default class InfoDocumentService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl
  }

  /** Veröffentlichte Dokumente in Anzeigereihenfolge (anonym). */
  async getPublished() {
    const response = await fetch(`${this.baseUrl}/infoDocument`)

    await throwIfNotOk(response)

    return await response.json()
  }

  /** Alle Dokumente inkl. unveröffentlichter (Administration). */
  async getAll(options) {
    const response = await fetch(`${this.baseUrl}/infoDocument/all`, {
      headers: authHeaders(options)
    })

    await throwIfNotOk(response)

    return await response.json()
  }

  async create({ title, description, file }, options) {
    const data = new FormData()
    data.append('title', title)

    if (description != null && description.length > 0) {
      data.append('description', description)
    }

    data.append('file', file, file.name)

    const response = await fetch(`${this.baseUrl}/infoDocument`, {
      body: data,
      headers: authHeaders(options),
      method: 'POST'
    })

    await throwIfNotOk(response)

    return await response.json()
  }

  async update(id, { title, description, isPublished }, options) {
    const response = await fetch(`${this.baseUrl}/infoDocument/${id}`, {
      body: JSON.stringify({ title, description, isPublished }),
      headers: {
        ...authHeaders(options),
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    await throwIfNotOk(response)

    return await response.json()
  }

  async replaceFile(id, file, options) {
    const data = new FormData()
    data.append('file', file, file.name)

    const response = await fetch(`${this.baseUrl}/infoDocument/${id}/file`, {
      body: data,
      headers: authHeaders(options),
      method: 'PUT'
    })

    await throwIfNotOk(response)

    return await response.json()
  }

  /** Vollständige Id-Reihenfolge; Antwort ist die neu sortierte Gesamtliste. */
  async reorder(ids, options) {
    const response = await fetch(`${this.baseUrl}/infoDocument/order`, {
      body: JSON.stringify({ ids }),
      headers: {
        ...authHeaders(options),
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    await throwIfNotOk(response)

    return await response.json()
  }

  async delete(id, options) {
    const response = await fetch(`${this.baseUrl}/infoDocument/${id}`, {
      headers: authHeaders(options),
      method: 'DELETE'
    })

    await throwIfNotOk(response)

    return true
  }
}
